<template>
  <div>
    <div role="button" aria-label="关闭弹窗" class="weui-mask">
      <div class="pop-login-wrap">
        <div class="login-head">
            请选择登录方式
            <!--      <a href="javascript:;" class="btn-close"></a>-->
        </div>
        <div class="login-ways" :class="{'login-ways-both':!hideWechat}">
          <ul>
            <li @click="loginQQ(url)">
                <i class="icon icon-qq"></i>
                <p style="font-size: 14px;">QQ登录</p>
            </li>
            <li v-if="!hideWechat" @click="loginWechat(url, offerId)">
                <i class="icon icon-wechat"></i>
                <p style="font-size: 14px;">微信登录</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Toast v-if="toastMsg" :toast-msg="toastMsg"></Toast>
  </div>
</template>

<script>
import * as userApi from "../../common/api/user"
import Toast from "./Toast.vue"
export default {
  components: {
    Toast
  },
  name: "LoginPrompt",
  props: ["url", "offerId", "hideWechat"],
  data() {
    return {
      toastMsg: ""
    }
  },
  methods: {
    loginQQ(url) {
      userApi.jumpToMqq(url)
    },
    loginWechat(url, offerId) {
      userApi
        .getOpenlink(
          {
            offerId
          },
          {
            url,
            match_mode: 1
          }
        )
        .then(res => {
          location.href = res.info.openlink
        })
        .catch(res => {
          let msg = "系统繁忙,请稍候再试！"
          if (!res.err_code && res.msg) {
            msg = res.msg
          }
          this.toastMsg = msg
          setTimeout(() => {
            this.toastMsg = null
          }, 2000)
        })
    }
  }
}
</script>

<style scoped>
.weui-mask {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
.weui-mask {
  background: rgba(0, 0, 0, 0.6);
}

.pop-login-wrap {
  position: absolute;
  z-index: 1001;
  width: 315px;
  background: #fff;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  border-radius: 9px;
}

.pop-login-wrap .login-head {
  position: relative;
  font-size: 16px;
  line-height: 44px;
  text-align: center;
  color: #000000;
}

.pop-login-wrap .login-head:before {
  position: absolute;
  display: block;
  content: "";
  bottom: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: #e0e0e0;
}

.pop-login-wrap .btn-close {
  position: absolute;
  right: 14px;
  top: 50%;
  width: 11px;
  height: 11px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAAHeEJUAAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpCQkQwMEEzMjQ2RDMxMUU4OUE1RERCNTkwNEQ0QjExRCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpCQkQwMEEzMzQ2RDMxMUU4OUE1RERCNTkwNEQ0QjExRCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkJCRDAwQTMwNDZEMzExRTg5QTVEREI1OTA0RDRCMTFEIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkJCRDAwQTMxNDZEMzExRTg5QTVEREI1OTA0RDRCMTFEIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+pLrjDQAAAc1JREFUeNpiuHnz5n8gYABhMGFsbPwfzoEJAAQQnANSjqoMxgBhgABCkUFmM4JlgcDExATMOHPmDCNYANl+ZEsAAlA1LicABCEMNWlA7L84O9AKZJYMuDC5xN+LVlXPQj1FdPdZJ2mMiJuVmQeAuTvupbSPJShDhYgf38H6zNgngMCGgxyP7gpk14DkP3z4gCkI04SsCCWIkPHdu3fBikCuR5cjzWRCbn779i1cE0AAOskuB4IICMKMeOI8buLvAo4m4SbOw7Pd1EzWYmYqkUj3l9bdhYQQHqH5gDlqrcR7/9/iJmPMp7V29QrQOXerDAi5ZSiAv+AOLZ8GQgLm9t4JbIsx0uHrDEJKqRMupdA5/lgRfjPGloqjx32gvccBWWtvU2utB0xxwVMpJfq2R845OaSUrxCUc6ZCCPIVoJNyOwEghIFguAqswqKsQLEfq7OYYzw8Ahp8BPwJyWrcUYkxNj/Z2vJ8tejjmOjknL8kIHFckgy/K67FQgg/nUPRjjh57oQ66jXq04fUmxDtTfq9aDEmnPUPJOmgKaUktdaGICh676WUIs4507BHFgGFx7EaX9/t7vjXRnXXTaM0Uie8mkh1+BnrFn4+RA3/C3KnyXdIJvKfAAAAAElFTkSuQmCC)
    no-repeat;
  background-size: 100% 100%;
  border: 6px solid transparent;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  box-sizing: content-box;
}

.pop-login-wrap .login-ways {
  position: relative;
  padding: 35px 0;
  text-align: center;
}

.login-ways-both:after {
  position: absolute;
  display: block;
  content: "";
  top: 0;
  left: calc(50% - 0.5px);
  width: 1px;
  height: 100%;
  background: #e0e0e0;
}

.pop-login-wrap .login-ways li {
  display: inline-block;
  width: 45%;
  text-align: center;
  color: #666;
}

.pop-login-wrap .login-ways li .icon-qq {
  background: url(//midas.gtimg.cn/h5/store/static/images/icon-qq.58ba615.png) no-repeat;
  background-size: 100% 100%;
}

.pop-login-wrap .login-ways li .icon-wechat {
  background: url(//midas.gtimg.cn/h5/store/static/images/icon-wechat.1d98680.png) no-repeat;
  background-size: 100% 100%;
}

.pop-login-wrap .login-ways li .icon {
  width: 45px;
  height: 45px;
  display: inline-block;
  margin-bottom: 10px;
}
</style>
